export const getNewCompReportPath = state => state.paths.newCompReport;

export const getSavedSearchIndexPath = state => state.paths.compSearches;